import {CallableFunctionName, PublishedResidualOptionsResults} from '@ozark/common';
import {useEffect, useState} from 'react';
import {Firebase} from '../../../firebase';
import {ResidualGroupOverrides} from './ResidualGroupOverrides';

export const PortalResidualGroupOverrides = () => {
  const [loadingResiduals, setLoadingResiduals] = useState(false);
  const [yearMonths, setYearMonths] = useState<string[] | null>(null);

  useEffect(() => {
    (async () => {
      setLoadingResiduals(true);
      const getPublishedResidualOptions = Firebase.functions.httpsCallable(
        CallableFunctionName.getPublishedResidualOptions
      );
      const result: {data: PublishedResidualOptionsResults} = await getPublishedResidualOptions({});
      setLoadingResiduals(false);
      if (!result?.data?.options) {
        return;
      }

      const options = result.data.options.sort();
      setYearMonths(options);
    })();
    // eslint-disable-next-line
  }, []);

  return <ResidualGroupOverrides loadingResiduals={loadingResiduals} yearMonths={yearMonths} />;
};
